export const injectHeadingIdsIntoDOM = (containerSelector: string): void => {
  const container = document.querySelector(containerSelector)
  if (!container) return

  const h2Elements = container.querySelectorAll('h2')
  h2Elements.forEach((h2, index) => {
    // Only add ID if it doesn't already exist
    if (!h2.id) {
      const text = h2.textContent?.trim() || ''
      let id = ''

      if (text) {
        // Generate ID from text content
        id = text
          .toLowerCase()
          .replace(/[^\w\s-]/g, '')
          .replace(/\s+/g, '-')
          .replace(/--+/g, '-')
          .trim()
        id = id ? `${id}-${index + 1}` : `heading-${index + 1}`
      } else {
        id = `heading-${index + 1}`
      }

      h2.id = id
    }
  })
}
